// account.js
import React from 'react';
import View from 'src/pages/dashboard/account';
import AppRender from 'src/routes/app-render';
import { MobileProvider } from 'src/contexts/mobile-context';

const Page = () => {
  return (
    <AppRender>
      <MobileProvider>
        <View />
      </MobileProvider>
    </AppRender>
  );
};

export default Page;
